import { type SessionType } from "@shared/feShared/auth/tokenExchange";
import { SESSION_TYPE_KEY, TOKEN_KEY } from "@/contants";

export const getTokenFromLocalStorage = (): string | null => localStorage.getItem(TOKEN_KEY);

export const setTokenToLocalStorage = (token: string | null | undefined): void => {
  if (!token) {
    localStorage.removeItem(TOKEN_KEY);
    return;
  }
  localStorage.setItem(TOKEN_KEY, token);
};

export const getSessionTypeFromLocalStorage = (): SessionType | null => {
  const value = localStorage.getItem(SESSION_TYPE_KEY);
  return value === "refreshable" || value === "non-refreshable" ? value : null;
};

export const setSessionTypeToLocalStorage = (type: SessionType | null): void => {
  if (type == null) {
    localStorage.removeItem(SESSION_TYPE_KEY);
    return;
  }
  localStorage.setItem(SESSION_TYPE_KEY, type);
};

export const clearAuthLocalStorage = (): void => {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(SESSION_TYPE_KEY);
};
